var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4953 22.0369C29.2519 21.2803 29.2519 20.0535 28.4953 19.2969C27.7386 18.5402 26.5119 18.5402 25.7552 19.2969L15.4219 29.6302C15.0436 30.0085 14.8544 30.5044 14.8544 31.0002C14.8544 31.2629 14.9067 31.5134 15.0014 31.7419C15.096 31.9704 15.2361 32.1845 15.4219 32.3702L25.7552 42.7036C26.5119 43.4602 27.7386 43.4602 28.4953 42.7036C29.2519 41.9469 29.2519 40.7202 28.4953 39.9635L21.4695 32.9377H46.5003C47.5703 32.9377 48.4378 32.0703 48.4378 31.0002C48.4378 29.9302 47.5703 29.0627 46.5003 29.0627H21.4695L28.4953 22.0369Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-left-icon.f4dcdeaf56b52ee1d0d43f069f4d1f39.svg";
export { ForwardRef as ReactComponent };